// TODO: Fix ESLint issues
/* eslint-disable import/no-default-export */
import { isDesktop, onTabletToDesktop } from '../utils/index.js';
import { createElement } from '../helpers/dom-elements.js';
import { createPesIcon } from '../../utils/utils';

let isPopupOpened = false;
let popupContentMsg;

function updateContent(content) {
  popupContentMsg.innerHTML = content;
}

function togglePopupFlag() {
  isPopupOpened = !isPopupOpened;
  return isPopupOpened;
}

function hideMobilePopup() {
  const popup = document.querySelector('.js-popup-msg-container');
  const popupExists = !!popup;

  if (popupExists) {
    popup.classList.toggle('is-opened');
  }

  togglePopupFlag();
}

/** @param {Event} e */
function closeMobilePopup(e) {
  if (e.target && e.target.matches('.js-close-popup')) {
    hideMobilePopup();
  }
}

/**
 * @param {string} content
 * @returns {HTMLDivElement} Created popupContainer element.
 */

function getMobilePopupLayout(content) {
  const popupContainer = document.createElement('div');

  popupContainer.className = 'popup-msg-container is-opened js-popup-msg-container';

  popupContainer.addEventListener('click', closeMobilePopup);

  const popupOverlay = document.createElement('div');

  popupOverlay.className = 'popup-overlay js-close-popup';

  popupContainer.appendChild(popupOverlay);

  const popupBody = document.createElement('section');

  popupBody.className = 'pes-popup popup--no-header';

  const popupCloseBtn = createElement('button', {
    type: 'button',
    className: 'close-button button-less popup__close-button js-close-popup',
    attributes: {
      'aria-label': 'Close'
    },
    contents: createElement('span', {
      className: 'vertical_middle',
      contents: createPesIcon({
          iconName: 'action_delete_cross',
          size: 'SMALL',
      })
    })
  });

  popupBody.appendChild(popupCloseBtn);

  const popupContent = document.createElement('div');

  popupContent.className = 'popup__content';

  popupContentMsg = document.createElement('div');
  popupContentMsg.className = 'popup__content-message';
  updateContent(content);

  popupContent.appendChild(popupContentMsg);
  popupBody.appendChild(popupContent);

  popupContainer.appendChild(popupBody);

  return popupContainer;
}

/** @param {string} popupMsg */
function openMobilePopup(popupMsg) {
  const popup = document.querySelector('.js-popup-msg-container');
  const popupExists = !!popup;

  if (!popupExists) {
    document.body.appendChild(getMobilePopupLayout(popupMsg));
  } else {
    updateContent(popupMsg);
    popup.classList.toggle('is-opened');
  }

  togglePopupFlag();
}

function init() {
  onTabletToDesktop(() => {
    if (isPopupOpened) {
      hideMobilePopup();
    }
  });
}

function show(popupMsg) {
  if (isDesktop() || isPopupOpened) {
    return;
  }

  openMobilePopup(popupMsg);
}

export default {
  init,
  show
};
